import { EuiBadge } from "@inscopix/ideas-eui";

type RoleBadgeProps = {
  role: string;
};

export const RoleBadge = ({ role }: RoleBadgeProps) => {
  return <EuiBadge color="hollow">{role}</EuiBadge>;
};
